// A declared new access policy never falls back to permissive legacy roles.
export function allowsAccess(access, profile, can) {
  if (!access || !profile?.id) return false
  if (access.mode === 'permissions') return can(access.key)
  if (access.mode === 'general-manager') return Boolean(profile.is_superuser || profile.groups?.some(group => group.code === 'general_manager'))
  return false
}

// Normal JWT refresh changes the token but keeps the account identity.
export function tokenSubject(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return String(payload.user_id || payload.sub || '')
  } catch (_) { return '' }
}
